import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchUsers } from "services/api/users";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { UserListPayload, UserListResponse, UserListSlice } from "types/users";
import { isFresh } from "utils/helpers";

const STALE_TIME = apiConfig.FETCH_USERS.staleTime;

export const fetchUserList = createAsyncThunk<{userList: UserListResponse, page: number}, UserListPayload, {rejectValue: string}>(
    'users/list',
    async ({ page, force = false }, { getState, rejectWithValue }) => {
        const state = getState() as { userList: UserListSlice, auth: AuthState };
        if (page === 1 && !force && isFresh(state.userList.last_fetched_at, STALE_TIME) && !state.userList.expired) {
            return rejectWithValue(ERROR.CACHED);
        }
        try {
            const userList = await fetchUsers(state.auth.selectedAgencyId!, {page});
            return { userList, page };
        } catch (error) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }
    }
);